<template>
  <div class="faq-feedback" data-faq-feedback-container="active" ref="feedbackContainer">
    <div class="faq-feedback__title">
      {{ phrase('faq-feedback-title', 'Heeft het antwoord u geholpen?') }}
    </div>
    <div class="faq-feedback__items">
      <span
        class="faq-feedback__item faq-feedback__item--positive"
        data-faq-feedback=""
        data-faq-feedback-value="positive"
        :data-faq-feedback-subject="subject"
        data-faq-feedback-type="thumb"
        data-faq-feedback-status=""
        :title="phrase('faq-feedback-label-positive', 'Duim omhoog')"
        @click="handleFeedback"
      >
        <span class="icon icon--thumbs-up"></span>
        <span class="icon icon--thumbs-up-solid icon--selected"></span>
      </span>
      <span class="faq-feedback__message">
        {{ phrase('faq-feedback-message-positive', 'Bedankt!') }}
      </span>
      <span
        class="faq-feedback__item faq-feedback__item--negative"
        data-faq-feedback=""
        data-faq-feedback-value="negative"
        :data-faq-feedback-subject="subject"
        data-faq-feedback-type="thumb"
        data-faq-feedback-status=""
        :title="phrase('faq-feedback-label-negative', 'Duim omlaag')"
        @click="handleFeedback"
      >
        <span class="icon icon--thumbs-up"></span>
        <span class="icon icon--thumbs-up-solid icon--selected"></span>
      </span>
      <span class="faq-feedback__message">
        {{
          phrase(
            'faq-feedback-message-negative',
            'Bedankt voor uw reactie! We doen ons best een beter antwoord te vinden.'
          )
        }}
      </span>
    </div>
  </div>
</template>

<script>
import { dictionaryMixin } from '@/mixins'
import { CycleIcon } from '@/components/elements'

export default {
  name: 'FaqFeedback',
  components: {
    CycleIcon
  },
  mixins: [dictionaryMixin],
  props: {
    message: {
      type: String,
      default: ''
    },
    subject: {
      type: String,
      default: 'fallBackTitle'
    }
  },
  methods: {
    handleFeedback(event) {
      const clickedElement = event.currentTarget
      const faqFeedbackContainer = this.$refs.feedbackContainer

      if (faqFeedbackContainer.getAttribute('data-faq-feedback-container') === 'active') {
        clickedElement.setAttribute('data-faq-feedback-status', 'selected')
        faqFeedbackContainer.setAttribute('data-faq-feedback-container', 'inactive')
      }
    }
  }
}
</script>
